import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiMetricsService from '@/services/banzai-metrics.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiMetrics = new BanzaiMetricsService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiMetrics: BanzaiMetricsService;
  }
}
